import Gallery from 'react-photo-gallery';
import React, { Component } from 'react';
var images ;



export default class Zoom extends Component {

  constructor(props) {
    super(props);

    images = this.props.record.gallery;

    console.log(images)

  }



  render() {
    const PHOTO_SET = [
  {
    src: images[0],
    width: 1,
    height: 1
  }
];

    return (
        <Gallery photos={PHOTO_SET} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/custom/gallery_complaint.js